module.exports = __webpack_public_path__ + "img/5-6.fa07d653.svg";